"use strict";
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCrud = void 0;
var tslib_1 = require("tslib");
var swr_1 = (0, tslib_1.__importDefault)(require("swr"));
var react_1 = require("react");
var __1 = require("..");
// T is the response type
// K is the request type, which defaults to T
function useCrud(url, key, fetchOptions) {
    var _this = this;
    var _a = (0, react_1.useState)(true), loading = _a[0], setIsLoading = _a[1];
    var loadingTimeout = function () {
        setIsLoading(false);
    };
    var fetch = (0, react_1.useCallback)(function (url, params) {
        if (params === void 0) { params = {}; }
        return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
            var response;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, __1.http.get({ url: url, params: params })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    }, []);
    var _b = (0, swr_1.default)(url, fetch, (0, tslib_1.__assign)({}, fetchOptions)), data = _b.data, error = _b.error, isValidating = _b.isValidating, mutate = _b.mutate;
    var search = (0, react_1.useCallback)(function (search, shouldRevalidate) {
        if (shouldRevalidate === void 0) { shouldRevalidate = false; }
        return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
            var response, result;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, __1.http.get({ url: url, params: search })];
                    case 1:
                        response = _a.sent();
                        result = response.data;
                        if (!(data && mutate)) return [3 /*break*/, 3];
                        return [4 /*yield*/, mutate(result, shouldRevalidate)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, result];
                }
            });
        });
    }, [url, data, mutate]);
    var create = (0, react_1.useCallback)(function (newObject, shouldRevalidate) {
        if (shouldRevalidate === void 0) { shouldRevalidate = false; }
        return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
            var response, result, newData;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, __1.http.post({ url: url, data: newObject })];
                    case 1:
                        response = _a.sent();
                        result = response.data;
                        if (!(data && mutate)) return [3 /*break*/, 3];
                        newData = data;
                        if (Array.isArray(data)) {
                            newData = data.concat(result);
                        }
                        return [4 /*yield*/, mutate((0, tslib_1.__spreadArray)([], Array.from(new Set(newData)), true), shouldRevalidate)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, result];
                }
            });
        });
    }, [url, data, mutate]);
    // const createMultiple = useCallback(
    //   async (newObjects: K[], shouldRevalidate = false) => {
    //     const response = await http.post({ url, data: newObjects })
    //     const result = response as unknown as T[]
    //     if (data && mutate) {
    //       await mutate([...data, ...result], shouldRevalidate)
    //     }
    //     return result
    //   },
    //   [url, data, mutate]
    // )
    var remove = (0, react_1.useCallback)(function (body, shouldRevalidate) {
        if (shouldRevalidate === void 0) { shouldRevalidate = false; }
        return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
            var response, result, updatedObjects, deletedIndex, updatedObjects;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, __1.http.delete({ url: "".concat(url, "/").concat(body) })];
                    case 1:
                        response = _a.sent();
                        result = response.data;
                        if (!(data && mutate)) return [3 /*break*/, 5];
                        if (!Array.isArray(result)) return [3 /*break*/, 3];
                        updatedObjects = (0, tslib_1.__spreadArray)([], data, true).filter(function (current) {
                            var isDeleted = result.find(function (result) { return result[key] === current[key]; });
                            return !isDeleted;
                        });
                        return [4 /*yield*/, mutate(result.length === 0 ? [] : updatedObjects, shouldRevalidate)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        deletedIndex = data.findIndex(function (object) { return object[key] === result[key]; });
                        if (!(deletedIndex >= 0)) return [3 /*break*/, 5];
                        updatedObjects = (0, tslib_1.__spreadArray)([], data, true);
                        updatedObjects.splice(deletedIndex, 1);
                        return [4 /*yield*/, mutate(updatedObjects, shouldRevalidate)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/, result];
                }
            });
        });
    }, [url, data, mutate, key]);
    var removeOne = (0, react_1.useCallback)(function () { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
        var response, result;
        return (0, tslib_1.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, __1.http.delete({ url: url })];
                case 1:
                    response = _a.sent();
                    result = response.data;
                    return [2 /*return*/, result];
            }
        });
    }); }, [url]);
    var archiveOne = function (customUrl) { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
        var response, result;
        return (0, tslib_1.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, __1.http.patch({ url: customUrl })];
                case 1:
                    response = _a.sent();
                    result = response.data;
                    return [2 /*return*/, result];
            }
        });
    }); };
    // const removeMultiple = useCallback(
    //   async (ids: number[], shouldRevalidate = false) => {
    //     const response = await http.delete({ url })
    //     const results = response as unknown as T[]
    //     if (data && mutate) {
    //       const updatedObjects = [...data].filter((current) => {
    //         const isDeleted = results.find(
    //           (result) => result[key] === current[key]
    //         )
    //         return !isDeleted
    //       })
    //       await mutate(updatedObjects, shouldRevalidate)
    //       return results
    //     }
    //   },
    //   [url, data, key, mutate]
    // )
    var update = (0, react_1.useCallback)(function (updatedObject, shouldRevalidate) {
        if (shouldRevalidate === void 0) { shouldRevalidate = false; }
        return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
            var currentObjectIndex, response, updatedObjects;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentObjectIndex = data.data.findIndex(function (object) { return object[key] === updatedObject[key]; });
                        return [4 /*yield*/, __1.http.patch({
                                url: "".concat(url, "/").concat(updatedObject[key]),
                                data: updatedObject,
                            })];
                    case 1:
                        response = _a.sent();
                        if (!(data && mutate)) return [3 /*break*/, 3];
                        updatedObjects = (0, tslib_1.__spreadArray)([], data.data, true);
                        updatedObjects.splice(currentObjectIndex, 1, response.data);
                        return [4 /*yield*/, mutate(updatedObjects, shouldRevalidate)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, response.data];
                }
            });
        });
    }, [data, url, mutate, key]);
    // const updateMultiple = useCallback(
    //   async (updatedObjects: T[], shouldRevalidate = false): Promise<T[]> => {
    //     // const currentObjects = data.filter((object) =>
    //     //   updatedObjects.find((updated) => object[key] === updated[key])
    //     // )
    //     const response = http.patch({ url, data: updatedObjects })
    //     if (data && mutate) {
    //       const updatedObjects = [...data].map((current) => {
    //         if (current[key] === response[key]) {
    //           return response
    //         }
    //         return current
    //       })
    //       await mutate(updatedObjects, shouldRevalidate)
    //     }
    //     return response as unknown as T[]
    //   },
    //   [url, data, mutate, key]
    // )
    (0, react_1.useEffect)(function () {
        if (isValidating) {
            setIsLoading(true);
            return;
        }
        setTimeout(loadingTimeout, 500);
    }, [isValidating]);
    var memoizedData = (0, react_1.useMemo)(function () { return (data && data.length !== 0 ? data : []); }, [data]);
    return {
        create: create,
        remove: remove,
        removeOne: removeOne,
        archiveOne: archiveOne,
        fetch: {
            data: memoizedData,
            error: error,
            loading: loading,
            mutate: mutate,
        },
        update: update,
        search: search,
    };
}
exports.useCrud = useCrud;
